import {
  Checkbox,
  FormControl,
  InputAdornment,
  ListItemText,
  MenuItem,
  SvgIcon,
  TextField,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useMemo, useState } from 'react'

interface IFilterOptions {
  options: { label: string; value: any }[]
  selected: { label: string; value: any }[]
  handleToggle: (option: { label: string; value: any }) => void
  className?: string
}

function CircleUncheckedIcon() {
  return (
    <SvgIcon>
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
    </SvgIcon>
  )
}

function CircleCheckedIcon() {
  return (
    <SvgIcon>
      <circle cx="12" cy="12" r="10" fill="currentColor" />
    </SvgIcon>
  )
}

export const FilterOptions = ({
  options,
  selected,
  handleToggle,
  className,
}: IFilterOptions) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [displayedOptions, setDisplayedOptions] =
    useState<{ label: string; value: any }[]>(options)

  const isFilterable = useMemo(() => options.length > 6, [options])

  const handleOnSearch = (value: string) => {
    setSearchTerm(value)

    if (value === '') {
      setDisplayedOptions(options)
    } else {
      setDisplayedOptions(
        options.filter((option: { label: string; value: any }) =>
          option.label.toLowerCase().includes(value.toLowerCase())
        )
      )
    }
  }

  return (
    <>
      {isFilterable && (
        <TextField
          value={searchTerm}
          onChange={(e) => handleOnSearch(e.target.value)}
          className="dropdown-search"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon></SearchIcon>
                </InputAdornment>
              ),
            },
          }}
        />
      )}
      <FormControl className="dropdown-container">
        {displayedOptions.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            onClick={() => handleToggle(option)}
            className={className}
          >
            <Checkbox
              checked={selected
                .map((select) => select.label)
                .includes(option.label)}
              icon={<CircleUncheckedIcon />}
              checkedIcon={<CircleCheckedIcon />}
              sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: 20,
                  color: '#0d00ff',
                },
              }}
            />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </FormControl>
    </>
  )
}
